import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export const useConfigurationStatus = () => {
  const [configStatus, setConfigStatus] = useState({
    hasActiveShopifyConfig: false,
    hasActiveErpConfig: false,
    isLoading: true,
    error: null
  });

  // Query for active Shopify configuration
  const { data: shopifyConfig, isLoading: shopifyLoading, error: shopifyError } = useQuery({
    queryKey: ['configurationStatus', 'shopify', 'active'],
    queryFn: async () => {
      try {
        const response = await api.get('/shopify-config/active');
        return response.data;
      } catch (error) {
        if (error.response?.status === 404) {
          return null; // No active config found
        }
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 0 // Always consider data stale to ensure fresh checks
  });

  // Query for active ERP configuration
  const { data: erpConfig, isLoading: erpLoading, error: erpError } = useQuery({
    queryKey: ['configurationStatus', 'erp', 'active'],
    queryFn: async () => {
      try {
        const response = await api.get('/erp-config/active');
        return response.data;
      } catch (error) {
        if (error.response?.status === 404) {
          return null; // No active config found
        }
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 0 // Always consider data stale to ensure fresh checks
  });

  useEffect(() => {
    const isLoading = shopifyLoading || erpLoading;
    const hasError = shopifyError || erpError;

    setConfigStatus({
      hasActiveShopifyConfig: !!(shopifyConfig?.data),
      hasActiveErpConfig: !!(erpConfig?.data),
      isLoading,
      error: hasError,
      shopifyConfig: shopifyConfig?.data,
      erpConfig: erpConfig?.data
    });
  }, [shopifyConfig, erpConfig, shopifyLoading, erpLoading, shopifyError, erpError]);

  return configStatus;
};
